import React from 'react'

const AutomationOptionsSunsetSunrise = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="34" viewBox="0 0 52 34" fill="none" className={className}>
    <path
      d="M13.0202 29.28C12.835 28.3919 12.7412 27.4872 12.7402 26.58C12.7389 24.8243 13.0839 23.0856 13.7555 21.4635C14.427 19.8413 15.412 18.3675 16.6539 17.1266C17.8958 15.8856 19.3703 14.9017 20.993 14.2314C22.6156 13.5611 24.3546 13.2174 26.1102 13.22C27.8659 13.2174 29.6049 13.5611 31.2275 14.2314C32.8502 14.9017 34.3247 15.8856 35.5666 17.1266C36.8085 18.3675 37.7934 19.8413 38.465 21.4635C39.1366 23.0856 39.4816 24.8243 39.4802 26.58C39.4793 27.4872 39.3855 28.3919 39.2002 29.28"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M26.1094 0V9.9" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M4.92969 26.59H9.41969" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M42.8105 26.59H47.3005" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M38.3398 14.85L43.5098 10.88" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M13.8907 14.85L8.7207 10.88" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M1.24023 33.32C6.60023 30.39 15.7402 28.45 26.1102 28.45C36.4802 28.45 45.6202 30.39 50.9802 33.32"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomationOptionsSunsetSunrise
